import React from "react";

export default function TecnologiasCards(props) {
  const { name, image } = props;
  return (
    <div className="flex w-full max-w-[9rem] min-w-0 flex-col items-center justify-center gap-2 rounded-xl border border-transparent py-2.5 transition-all duration-300 hover:scale-105 hover:border-2 hover:border-orange-500 sm:max-w-[10rem] md:max-w-[10.5rem]">
      <div className="flex h-14 w-14 items-center justify-center rounded-xl bg-white/95 p-2 shadow-sm ring-1 ring-black/5 sm:h-16 sm:w-16 md:h-[4.5rem] md:w-[4.5rem]">
        <img
          className="h-full w-full max-h-full max-w-full object-contain"
          src={image}
          alt=""
          role="presentation"
        />
      </div>
      <p className="text-center text-sm font-medium leading-snug text-white sm:text-base md:text-[1.05rem]">
        {name}
      </p>
    </div>
  );
}
